module.exports = __webpack_public_path__ + "static/img/lqr_logo.f4c249fc.png";